import { IconBrandsFacebook } from '@doltech/icons/IconBrandsFacebook';
import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { DolFacebookShareButton } from '@doltech/ui/lib/figma/Social/DolFacebookShareButton';
import { Image } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

import { Separator } from '@doltech/ui/lib/figma/Layout/Landing/Content/Separator';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { useBookSEOPageContext } from '../BookSEOPageContext';

interface BookSEOHeadingProps extends React.HTMLAttributes<HTMLDivElement> {}

export const BookSEOHeadingDesktop = (props: BookSEOHeadingProps) => {
  const { bookDetail } = useBookSEOPageContext();
  const { ...rest } = props;

  return (
    <Container {...rest}>
      <BookOverviewWrapper>
        <Image
          alt={bookDetail?.thumbnail?.alt || bookDetail.seoPage?.dol?.title}
          src={bookDetail?.thumbnail?.url}
          style={{ borderRadius: 8 }}
          loading="eager"
          width={200}
        />
        <InfoWrapper>
          <ResponsiveTypography.Title
            level={1}
            variant="bold/40"
            ellipsis={{ rows: 2 }}
            className="book-title"
            color="black100"
          >
            {bookDetail.seoPage?.dol?.title}
          </ResponsiveTypography.Title>
          <MetaInfo>
            <ResponsiveTypography.Text variant="regular/16-24" color="black80">
              {bookDetail.noOfTests} bài tests
            </ResponsiveTypography.Text>
            <Separator variant="dot" bg="gray40" width="3px" height="3px" />
            <ResponsiveTypography.Text variant="regular/16-24" color="black80">
              {bookDetail.testTakers >= 1000
                ? (bookDetail.testTakers / 1000).toFixed(3)
                : bookDetail.testTakers || 0}{' '}
              lượt làm
            </ResponsiveTypography.Text>
          </MetaInfo>
          <DolFacebookShareButton
            pageId={bookDetail.seoPage?.id}
            className="social-button"
            key="facebook-share"
            url={bookDetail.seoPage?.url}
          >
            <Button.Link>
              <IconBrandsFacebook fontSize={20} />
              <ResponsiveTypography.Text variant="semi-bold/14" style={{ paddingLeft: 8 }}>
                Share
              </ResponsiveTypography.Text>
            </Button.Link>
          </DolFacebookShareButton>
        </InfoWrapper>
      </BookOverviewWrapper>

      <ResponsiveTypography.Paragraph
        className="desc-text"
        variant="regular/16"
        color="black100"
        ellipsis={{
          rows: 3,
          expandable: true,
          symbol: (
            <ResponsiveTypography.Text variant="semi-bold/14">xem thêm</ResponsiveTypography.Text>
          ),
        }}
      >
        {bookDetail.seoPage?.dol?.description}
      </ResponsiveTypography.Paragraph>
    </Container>
  );
};

const BookOverviewWrapper = styled.div`
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr);
  align-items: center;
  gap: 16px;
  img {
    object-fit: cover;
  }
`;

const InfoWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  gap: 8px;

  button {
    color: ${colorsV2.blue100};
    width: max-content;
  }
`;

const MetaInfo = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
  gap: 8px;
`;

const Container = styled.header`
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  gap: 16px;
`;
